// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"Carousel_Carousel__V832h","CarouselPaginationSummary":"Carousel_CarouselPaginationSummary__1lmuR"};